import { SxProps, Theme } from "@mui/material";

interface IStyles {
  [index: string]: Record<string, SxProps<Theme>>;
}

export const styles: IStyles = {
  Skeletons: {
    paginationSkeleton: {
      margin: "24px 0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    areaSkeletonsContainer: {
      display: "grid",
      gap: "24px",
      margin: "32px 0 0 0",
    },
  },
  CreateAreaResult: {
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
  },
  AreaResult: {
    manager: {
      margin: "0 0 8px 0",
    },
    avatarContainer: { display: "flex", alignItems: "center", gap: "8px" },
  },
  Areas: {
    areasContainer: {
      display: "grid",
      gap: "24px",
    },
    paginationContainer: {
      margin: "24px 0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  FilterBar: {
    root: {
      display: "flex",
      alignItems: "center",
      gap: "16px",
    },
  },
};
